import NavBar from "./components/NavBar.component";
import Slider from "./components/Slider.component";
import OutStory from "./components/AboutOurStory/OutStory.component";
import LeadershipProfile from "./components/AboutOurStory/LeadershipProfile.component";
import MissionVision from "./components/AboutOurStory/MissionVision.component";
import WhyUs from "./components/AboutOurStory/WhyUs.component";
import NewsLetter from "./components/NewsLetter.component";
import Footer from "./components/Footer.component";

import Banner14 from "./assets/Banner14.svg";
import { useEffect, useRef } from "react";
import CustomScrollbar from "./components/CustomScrollbar.component";

function AboutOurStory() {
    const sliderRef = useRef(null);

    // Scroll to slider on first render
    useEffect(() => {
        if (sliderRef.current) {
            window.scrollTo({
                top: sliderRef.current.offsetTop,
                behavior: 'smooth',
            });
        }
    }, []);
    return (
        <section className="">
            {/* NAVIGATION BAR */}
            <section className="">
                <NavBar />
            </section>

            {/* NAV-CONTACT */}
            <section >{/* <NavContact/> */}</section>

            {/* HERO SLIDER */}
            <section ref={sliderRef}>
                <Slider images={[Banner14]} />
            </section>

            {/* OUR STORY */}
            <section>
                <OutStory />
            </section>

            {/* LEADERSHIP PROFILE */}
            <section>
                <LeadershipProfile />
            </section>

            {/* MISSION + VISION */}
            <section>
                <MissionVision />
            </section>

            {/* WHY US */}
            <section>
                <WhyUs />
            </section>

            {/* NEWS-LETTER */}
            <section>
                <NewsLetter />
            </section>

            {/* FOOTER */}
            <section>
                <Footer />
            </section>

            <CustomScrollbar />
        </section>
    );
}

export default AboutOurStory;
